"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressInfo = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _Address = require("../Address");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
  display: 'block'
});
const AddressName = (0, _mui.styled)(_mui.Typography)(({
  ownerState: {
    isDisplayedInMainPage
  }
}) => ({
  fontWeight: 'bold',
  ...(!isDisplayedInMainPage && {
    ...(0, _shared.lineClampStyles)(2)
  })
}));
const AddressInfo = ({
  name,
  isDisplayedInMainPage,
  isFlatSelection,
  ...props
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const [isOpenTooltip, setIsOpenTooltip] = (0, _react.useState)(false);
  const addressNameComponent = (0, _react.useRef)(null);
  const {
    addressFormat
  } = (0, _contexts.useCheckoutDeliveryContext)();

  // handleClick is implemented because of possibility to click on instant results without selecting address
  const handleAddressNameClick = (0, _react.useCallback)(() => {
    setIsOpenTooltip(prevState => !prevState);
  }, []);
  const handleMouseEnter = (0, _react.useCallback)(() => setIsOpenTooltip(true), []);
  const handleMouseLeave = (0, _react.useCallback)(() => setIsOpenTooltip(false), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ...getTestIdProps(_models.TestId.DeliveryBoxAddressInfo),
    "data-di-mask": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      open: isOpenTooltip ? (0, _checkoutUtils.isEllipsisActive)(addressNameComponent.current) : false,
      placement: "top-start",
      title: name,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AddressName, {
        ref: addressNameComponent,
        ownerState: {
          isDisplayedInMainPage,
          isFlatSelection
        },
        onClick: handleAddressNameClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ...getTestIdProps(_models.TestId.DeliveryBoxAddressName),
        children: name
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Address.Address, {
      ...props,
      forceSingleLine: isFlatSelection ?? isDisplayedInMainPage,
      addressFormat: addressFormat
    })]
  });
};
exports.AddressInfo = AddressInfo;